import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhySection from './components/WhySection';
import ComparisonTable from './components/ComparisonTable';
import HowItWorks from './components/HowItWorks';
import BlogSection from './components/BlogSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhySection />
        <ComparisonTable />
        <HowItWorks />
        <BlogSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}